import React, { useContext } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import DataContext from '../../Contexts/DataContext';
import { useAuth } from '../../Contexts/AuthContext';
import AddProForma from '../../Pages/ProjectHome/AddProForma';
import { toast } from 'react-toastify';

export default function ProFormaTab({ isDataFullyLoaded = true, onClose }) {
  const auth = useAuth();
  const activeUser = auth.activeUser;
  const context = useContext(DataContext);
  const { activeProjectInfo } = context;

  const handleAddProForma = async (change) => {
    if (!isDataFullyLoaded) {
      toast.warning('Please wait for project data to finish loading');
      return false;
    }

    try {
      const newChangeData = await context.saveAccountChange(
        change,
        activeUser.id,
        activeProjectInfo.id,
        activeUser.accessToken
      );

      if (newChangeData) {
        // Reload changes from API
        await context.setActiveProjectChangesAttribute(
          activeProjectInfo.id,
          activeUser.accessToken
        );

        toast.success(`Added pro forma "${change.change_label}" successfully.`);
        
        // Close the modal after successful creation
        if (onClose) {
          onClose();
        }
        
        return true;
      } else {
        toast.error(`Adding pro forma "${change.change_label}" failed.`);
        return false;
      }
    } catch (error) {
      console.error('Error adding pro forma:', error);
      toast.error('An error occurred while adding the pro forma.');
      return false;
    }
  };

  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };

  if (!isDataFullyLoaded) {
    return (
      <Box sx={{ p: 2, bgcolor: 'info.light', borderRadius: 1 }}>
        <Typography variant="body2" color="info.dark">
          Loading project data... Please wait before creating pro forma statements.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: -2 }}>
      <AddProForma
        addChange={handleAddProForma}
        cancelChange={handleCancel}
        toggleEditing={handleCancel}
        isInModal={true}
      />
    </Box>
  );
}
